// ToggleSwitch.jsx
import React from "react";

const ToggleSwitch = ({
  label,
  name,
  value,
  onChange,
  disabled = false,
  required = false,
  className,
  error,
}) => {
  const handleToggle = () => {
    if (!disabled) {
      onChange(name, !value);
    }
  };

  return (
    <div className={`flex flex-col ${className}`}>
      {label && (
        <label className="text-gray-700 mb-2 font-regular flex items-center text-sm">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <button
        type="button"
        onClick={handleToggle}
        disabled={disabled}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 ${
          disabled
            ? "bg-gray-400 cursor-not-allowed"
            : value
            ? "bg-green-500"
            : "bg-gray-300"
        }`}
        aria-label={label}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-300 ${
            value ? "translate-x-6" : "translate-x-1"
          }`}
        />
      </button>
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default ToggleSwitch;
